import { render, staticRenderFns } from "./StatsView.vue?vue&type=template&id=6dd44ba0&scoped=true&"
import script from "./StatsView.vue?vue&type=script&lang=js&"
export * from "./StatsView.vue?vue&type=script&lang=js&"
import style0 from "./StatsView.vue?vue&type=style&index=0&id=6dd44ba0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd44ba0",
  null
  
)

export default component.exports